import { useTranslation } from 'react-i18next';

/**
 * Custom hook to get translated page title
 * @param titleKey - The key for the page title in the translation files
 * @param defaultTitle - Default title to use if translation is not found
 * @returns Translated page title
 */
export const usePageTitle = (titleKey: string, defaultTitle: string = 'Piika') => {
  const { t } = useTranslation();
  
  // Try to get the translation, fallback to default title if not found
  return t(titleKey, { defaultValue: defaultTitle });
};

/**
 * Set the document title with a translated string
 * @param title - The translated title to set
 */
export const setDocumentTitle = (title: string) => {
  document.title = title ? `${title} | Piika` : 'Piika';
}; 